import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "@/components/controls/Modal";
import Text from "@/components/ui/text";
import { Button } from "@/components/ui/button";

interface Props {
  isOpen: boolean;
  isDiscarding: boolean;
  onKeep: () => void;
  onConfirm: () => void;
}

export const DiscardAmendmentDialog: React.FC<Props> = ({
  isOpen,
  isDiscarding,
  onKeep,
  onConfirm
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={isOpen}
      // Every dismiss route reads as "keep it", never as consent.
      setIsOpen={(open) => !open && onKeep()}
      contentClassname="w-[35rem]"
      // Nothing dismisses the dialog while the request is in flight, so the
      // close control goes with the Keep button rather than dead-clicking.
      showCloseButton={!isDiscarding}
      data-test="discard-amendment-dialog"
      // `hideDivider` drops only the body's border; the header carries its own.
      headerClassname="border-b-0"
      title={
        // Every lgSubtitle* variant carries `capitalize`.
        <Text as="span" variant="lgSubtitleH1" className="normal-case">
          {t("contracts.termsHistory.discardAmendment.title")}
        </Text>
      }
      content={
        <div className="px-4 pb-4 pt-2">
          <Text variant="bodySecondary" data-test="discard-amendment-message">
            {t("contracts.termsHistory.discardAmendment.message")}
          </Text>
        </div>
      }
      footer={
        <div className="flex justify-end gap-2">
          <Button
            variant="secondary"
            disabled={isDiscarding}
            onClick={onKeep}
            data-test="discard-amendment-keep"
          >
            {t("cancel")}
          </Button>
          <Button
            destructive
            disabled={isDiscarding}
            onClick={onConfirm}
            data-test="discard-amendment-confirm"
          >
            {t("contracts.termsHistory.discardAmendment.confirm")}
          </Button>
        </div>
      }
      hideDivider
    />
  );
};
